import React from "react";
import sponsor_2025_1 from "../image/tarumt_logo.png";

// Sponsor data
const sponsors = [
  { image: sponsor_2025_1, alt: "Sponsor 1" }
];

export default function Sponsors() {
  return (
    <section id="sponsors" className="text-white bg-black py-5">
      <div className="container text-center">
        <h2 className="mb-4">Sponsors</h2>

        <div className="row justify-content-center">
          {sponsors.map((sponsor, index) => (
            <div
              key={index}
              className="col-12 col-sm-6 col-md-4 mb-4 d-flex justify-content-center"
              style={{ padding: "10px" }}
            >
              <div
                style={{
                  width: "300px",
                  height: "150px",
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px"
                }}
              >
                <img
                  src={sponsor.image}
                  alt={sponsor.alt}
                  style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    objectFit: "contain"
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
